import CollapseItem from './item';
import {mapChildren, getRestProps} from '../utils';

export default function(obj, _Vdt, blocks, $callee) {
    _Vdt || (_Vdt = Vdt);
    obj || (obj = {});
    blocks || (blocks = {});
    var h = _Vdt.miss.h, hc = _Vdt.miss.hc, hu = _Vdt.miss.hu, widgets = this && this.widgets || {}, _blocks = {}, __blocks = {},
        __u = _Vdt.utils, extend = __u.extend, _e = __u.error, _className = __u.className, __slice = __u.slice, __noop = __u.noop,
        __m = __u.map, __o = __u.Options, _getModel = __o.getModel, _setModel = __o.setModel,
        _setCheckboxModel = __u.setCheckboxModel, _detectCheckboxChecked = __u.detectCheckboxChecked,
        _setSelectModel = __u.setSelectModel,
        self = this.data, $this = this, scope = obj, Animate = self && self.Animate, parent = ($callee || {})._super;

    const {className, value, children, arrow, noBorder} = self.get();

const classNameObj = {
    'k-collapse': true,
    [className]: className,
    'k-left': arrow === 'left',
    'k-border': !noBorder,
};

let index = 0;
const _children = mapChildren(children, vNode => {
    if (vNode.tag === CollapseItem) {
        const props = vNode.props;
        const _props = {_parent: self};
        if (props.value == null) {
            _props.value = `$${index++}`;
        }

        vNode.props = {...props, ..._props};
        vNode.$ = true;
    }
    return vNode;
});

    return h('div', {
        ...function() {try {return (getRestProps(self) )} catch(e) {_e(e)}}.call($this)
    }, function() {try {return (_children )} catch(e) {_e(e)}}.call($this), _className(function() {try {return (classNameObj )} catch(e) {_e(e)}}.call($this)))
}